<template>

  <div>

    <div class="project-intro">
      <div class="preview">
        <img src="../../assets/portfolio/tripdaze-screens.png" alt="Tripdaze">
      </div>
      <div class="intro-text">
        <p>
          <a href="https://www.tripdaze.com/" target="blank">Tripdaze</a> 
          is an awesome new hotel booking platform, that empowers people to 
          find the best deals on hotels all over the world! This site is still 
          under development, at the time of posting this, so be sure to check back 
          in the near future for updates... but, I feel it is already 
          looking great and in a state worthy of showing off, so I coudn't wait to include it!
        </p>
        <ul>
          <!-- <li>Branding</li> -->
          <li>UX</li>
          <li>UI</li>
          <!-- <li>Product Design</li> -->
          <li>Design</li>
        </ul>
      </div>
    </div>
    <div class="case-study">
      <div class="browser bar">
        <img src="../../assets/portfolio/tripdaze-1.jpg" alt="Tripdaze">
      </div>
      <div class="browser">
        <img src="../../assets/portfolio/tripdaze-scene-1.jpg" alt="Tripdaze">
      </div>
      <div class="browser bar">
        <img src="../../assets/portfolio/tripdaze-2.jpg" alt="Tripdaze">
      </div>
      <div class="browser">
        <img src="../../assets/portfolio/tripdaze-tablet-and-mobile.jpg" alt="Tripdaze">
      </div>
      <!-- <div class="browser bar">
        <img src="../../assets/portfolio/tripdaze-4.png" alt="Tripdaze">
      </div> -->
      <!-- <div class="browser bar">
        <img src="../../assets/portfolio/tripdaze-5.png" alt="Tripdaze">
      </div> -->
    </div>

    <div class="project-outro">
      <div class="outro-text">
        <h2>Design overhaul</h2>
        <p>
          This project had a large number of design needs, on top of the complete interface overhaul! I helped them completely re-design their site's look. So far most of the work was spent creating mockups. But it's coming out great!
        </p>
      </div>
      <div class="outro-img">
        <img src="../../assets/portfolio/photoshop-colors.png" alt="photoshop">
      </div>
    </div>

  </div>


  </div>

</template>

<script>
export default {
  name: "tripdaze",
  props: ["title", "subtitle", "hero"]
};
</script>

<style scoped lang="scss">
</style>
